export interface EventAdvancedConfigVisibilityMatchRule {
  tenantId: string;
  eventTypeId: number | null;
  eventSubTypeId: number | null;
  requiresRecurrent: boolean;
  active: boolean;
}

export interface EventAdvancedConfigVisibilityContext {
  tenantId: string | null | undefined;
  eventTypeId: number | null | undefined;
  eventSubTypeId: number | null | undefined;
  isRecurrent: boolean;
}

const matchesScopeDimension = (
  ruleValue: number | null,
  contextValue: number | null | undefined
): boolean => ruleValue == null || ruleValue === contextValue;

export const isEventNotificationSuppressionVisible = (
  rules: ReadonlyArray<EventAdvancedConfigVisibilityMatchRule>,
  context: EventAdvancedConfigVisibilityContext
): boolean => {
  if (!context.tenantId) {
    return false;
  }

  return rules.some((rule) => {
    if (!rule.active) {
      return false;
    }
    if (rule.tenantId !== context.tenantId) {
      return false;
    }
    if (!matchesScopeDimension(rule.eventTypeId, context.eventTypeId)) {
      return false;
    }
    if (!matchesScopeDimension(rule.eventSubTypeId, context.eventSubTypeId)) {
      return false;
    }
    if (rule.requiresRecurrent && !context.isRecurrent) {
      return false;
    }
    return true;
  });
};
